import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import { useTheme, Drawer, Paper } from '@material-ui/core';
import DeleteBtn from 'components/Custom/DeleteBtn';
import EditBtn from 'components/Custom/EditBtn';
import withAppStylesGrid from 'HOCs/withAppStyles';
import StaticWItemForm from './StaticWItemForm'
import ButtonLink from 'components/Shared/ButtonLink';
import { useCanDoAction } from 'hooks/useCanDoAction';
import withInspectionLink from 'HOCs/withInspectionLink';

const Grid = ({ columns, title, getRecords, selectedProject, component, formPath, deleteRecord, enable = { "delete": true, "edit": true }, selection = { "display": false }, data = [], options,customFilter }) => {
    const theme = useTheme();
    const [updateDate, setUpdateDate] = useState(new Date());
    const [editable, setEditable] = useState({});
    const [detailsPanel, setDetailsPanel] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerContent, setDrawerContent] = useState(null);
    const canDelete = useCanDoAction(component, 'delete');
    const canUpdate = useCanDoAction(component, 'update')

    const handleWorkItemClick = (event) => {
        event.stopPropagation()
        setDrawerOpen(true)
        const woItemNumber = event.target.valueOf().innerText
        setDrawerContent(() => (
            <StaticWItemForm woItemNumber={woItemNumber} />
        ))
    };

    useEffect(() => {
        let mounted = true;
        const handleChange = () => setUpdateDate(new Date());
        canDelete && mounted && enable.delete && setEditable(DeleteBtn(setUpdateDate, deleteRecord, selectedProject)); // delete
        canUpdate && mounted && enable.edit && setDetailsPanel(EditBtn(handleChange, formPath));   // edit
        return () => mounted = false; // cleanup hook
    }, [selectedProject, updateDate, enable, deleteRecord, formPath, canDelete, canUpdate]);

    const _getRecords = data.length > 0 ? data : async (page, pageSize, orderBy, orderDirection, search, _filters, includeHistory) => {
        const r = await getRecords(page, pageSize, orderBy, orderDirection, { status: selection.status }, _filters,customFilter, includeHistory);
        return {
            data: r.data,
            count: r.count
        }
    };

    const  GridWithAppStyles = withInspectionLink(
        withAppStylesGrid(MaterialTable, { theme, getRecords: _getRecords, defaultFilters: { projectId: selectedProject, status: selection.status }, exportFilter: true }),
    { inspectionColumnTitle: "Inspection #" });

        
    return (
        <div>
            <GridWithAppStyles
                key={updateDate}
                style={{ boxShadow: "0 0 0 0",  }}
                options={{
                    ...options,
                 
                        maxBodyHeight: '500px',
                        headerStyle: {
                            position: "sticky",
                            top: "0"
                          },
                      
                }}
                padding="default"
                columns={columns.map(col => {
                    if (col.title === "WorkItem #") {
                        col.render = (rowData) => (<ButtonLink onClick={handleWorkItemClick} href="#">{rowData[col.field]}</ButtonLink>)
                    }

                    return col
                })}
                title={title}
                detailPanel={detailsPanel}
                editable={editable}
                actions={selection.display ? [
                    {
                        tooltip: selection.tooltip,
                        icon: () => <Paper variant="outlined" style={{padding: 8, fontVariant: "all-petite-caps", fontWeight: 100, }}>{selection.btnText}</Paper>,
                        onClick: (evt, data) => selection.callback(data)
                    }
                ] : []
                }
            />
            <Drawer anchor="right" open={drawerOpen} onClose={() => { setDrawerOpen(false) }}>
                <div style={{ width: "25vw" }}>
                    {drawerContent}
                </div>
            </Drawer>
        </div>
    )
}

export default Grid